module.exports = __webpack_public_path__ + "static/media/value-prop-frame-1.b3fdef43.svg";